import { FieldValidation } from 'webclient.constants';

const validateMaxLength = (
  value: string,
  maxLength: number,
  fieldName: string
): FieldValidation => {
  if (value && value.length > maxLength) {
    return `${fieldName} must be ${maxLength} characters or less.`;
  }
  return true;
};

export default validateMaxLength;
